import { z } from 'zod'

import {
  civilDateSchema,
  demandProcurementBgInputSchema,
  planMasterCodeInputSchema,
  planMasterRowValidFromRefine,
  validPeriodRefine,
  validPeriodRefineIssue,
} from '~/pages/AdminOcctoMaster/tabs/_common/schema'

/**
 * 需要調達計画マスタ Create / Edit 共通 Zod schema。
 *
 * Create では bgMasterId / bgCode (new) を指定する。
 * Update では id のみで識別し bgCode / bgMasterId は変更不可。
 * codes[] / bgs[] は full replacement (PUT セマンティクス)。
 * validFrom (必須) / validTo (任意) は本マスタの適用期間
 * (occto-master-valid-period-6tabs 設計書 AC-02/AC-03/AC-05)。
 */
export const demandProcurementMasterFormSchema = z
  .object({
    /** BG マスタ UUID (Create のみ使用) */
    bgMasterId: z.string().min(1, 'BG を選択してください'),
    /** OCCTO 5 桁 BG コード (Read-only / Create 時スナップショット) */
    bgCode: z.string().min(1, 'BG コードは必須です'),
    /**
     * 備考 (任意)。 proto CEL `max_len 100` 新設 (Create/Update Request の
     * note field のみ、AC-11、3938-occto-master-plan-spec-followup 設計書 §5)。
     */
    note: z.string().max(100, '備考は100文字以内で入力してください').optional(),
    /**
     * 取引相手コードリスト。 1 件以上必須 (AC-01、spec AC-OMC-001)。
     */
    codes: z
      .array(planMasterCodeInputSchema)
      .min(1, '取引先を1件以上選択してください'),
    /** 所属 BG リスト (行ごとの期間は持たない、AC-12) */
    bgs: z.array(demandProcurementBgInputSchema),
    /** 適用開始日 (必須) */
    validFrom: civilDateSchema,
    /** 適用終了日 (任意) */
    validTo: civilDateSchema.optional(),
  })
  .refine(validPeriodRefine, validPeriodRefineIssue)
  .superRefine((value, ctx) => {
    planMasterRowValidFromRefine(
      value.validFrom,
      value.codes,
      '取引先の適用開始日はレコードの適用開始日以降の日付で入力してください',
      'codes',
      ctx,
    )
  })

export type DemandProcurementMasterFormValues = z.infer<
  typeof demandProcurementMasterFormSchema
>
